import React, { useState } from "react";
import axios from "axios";
import "./reset.css";
import "./Signup.css";
import { useNavigate } from "react-router-dom";

const Reset = () => {
  const [passwordData, setPasswordData] = useState({
    email: "",
    password: "",
    newPassword: "",
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPasswordData({ ...passwordData, [name]: value });
    console.log({ ...passwordData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      email: passwordData.email,
      password: passwordData.password,
      newPassword: passwordData.newPassword,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_API_URL}/check-email`,
        payload
      );

      if (response.status === 200) {
        alert("Password reset successful!");
        navigate("/");
      }

      console.log("API Response:", response);
    } catch (error) {
      console.error("API Error:", error);
      alert(
        "Password reset failed. Please check your credentials and try again."
      );
    }
  };

  return (
    <div className="reset-container">
      <form onSubmit={handleSubmit} className="reset-form">
        <div className="mb-3 logo-container">
          <img src="almadinalogo.jpeg" alt="Logo" className="logo" />
        </div>
        <div className="reset-input-box">
          <label>
            Email <span className="reset-required">*</span>
          </label>
          <input
            type="email"
            name="email"
            value={passwordData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="reset-input-box">
          <label>
            Old Password <span className="reset-required">*</span>
          </label>
          <input
            type="password"
            name="password"
            value={passwordData.password}
            onChange={handleChange}
            required
          />
        </div>
        <div className="reset-input-box">
          <label>
            New Password <span className="reset-required">*</span>
          </label>
          <input
            type="password"
            name="newPassword"
            value={passwordData.newPassword}
            onChange={handleChange}
            required
          />
        </div>
        <button type="submit" className="reset-button">
          Reset Password
        </button>
        <div className="logo-container">
          <h5>Powered by</h5>
          <img src="bayanat.png" alt="Powered by" className="powered-by" />
        </div>
      </form>
    </div>
  );
};

export default Reset;
